import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';

const OtpGuard = ({ children }) => {
  const { isAuthenticated, otpPending, user } = useAuth();
  if (isAuthenticated) {
    return <Redirect to={user && user.role === 'EXAM_CENTER' ? '/app/exam-center' : '/app/dashboard'} />;
  }
  if (!otpPending) return <Redirect to="/auth/login" />;
  return <>{children}</>;
};

OtpGuard.propTypes = { children: PropTypes.node };
export default OtpGuard;
